import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from "@emotion/react";
import Checked from "@engineering/icons/checked";
import { Subtitle, Button, Ui } from "@silvertours/front-shared";
import Image from "next/image";
import DriverIllustration from "./driver_illustration.png";
import { BenefitsWrapper, BenefitText, BenefitWrapper, ImageWrapper, JoinButton, LinkWrapper, MembershipWrapper } from "./MembershipPopover.styles";
import { analytics } from "../..";
var BenefitItem = function(param) {
    var benefit = param.benefit;
    var theme = useTheme();
    return benefit && benefit !== "" && benefit !== "null" ? /*#__PURE__*/ _jsxs(BenefitWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Checked, {
                width: "24px",
                fill: theme.color.primary
            }),
            /*#__PURE__*/ _jsx(BenefitText, {
                inline: true,
                children: benefit
            }, benefit)
        ]
    }) : null;
};
var MembershipPopover = function(param) {
    var handleLoginClick = param.handleLoginClick, handleSignUpClick = param.handleSignUpClick, _translations = param.translations, welcomeSubtitle = _translations.welcomeSubtitle, loginButton = _translations.loginButton, joinButton = _translations.joinButton, benefitsSubtitle = _translations.benefitsSubtitle, benefits = _translations.benefits, moreInfoLink = _translations.moreInfoLink;
    var onJoinClick = function() {
        analytics.gtm.trackNewUser({
            isLoggedIn: false
        });
        handleSignUpClick();
    };
    return /*#__PURE__*/ _jsxs(MembershipWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Subtitle, {
                as: "p",
                children: welcomeSubtitle
            }),
            /*#__PURE__*/ _jsx(ImageWrapper, {
                children: /*#__PURE__*/ _jsx(Image, {
                    src: DriverIllustration,
                    objectFit: "contain",
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                onClick: handleLoginClick,
                children: loginButton
            }),
            /*#__PURE__*/ _jsx(JoinButton, {
                onClick: onJoinClick,
                variant: "secondary",
                children: joinButton
            }),
            /*#__PURE__*/ _jsx(Subtitle, {
                children: benefitsSubtitle
            }),
            /*#__PURE__*/ _jsx(BenefitsWrapper, {
                children: benefits === null || benefits === void 0 ? void 0 : benefits.map(function(param) {
                    var benefit = param.benefit;
                    return /*#__PURE__*/ _jsx(BenefitItem, {
                        benefit: benefit
                    }, benefit);
                })
            }),
            moreInfoLink && /*#__PURE__*/ _jsx(LinkWrapper, {
                children: /*#__PURE__*/ _jsx(Ui.TextLink, _object_spread({}, moreInfoLink))
            })
        ]
    });
};
export { MembershipPopover };
